import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'patientCode'
})
export class PatientCodePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (value !== null && value !== undefined) {
      return 'PBO' + this.pad(value as number, 5);
    }
    return '';
  }

  pad(num: number, size: number): string {
    let s = num + '';
    while (s.length < size) {
      s = '0' + s;
    }
    return s;
}
}
